import React, { useEffect, useState } from "react";
import axios from "axios";
import { Row, Col, Form, Button, Container } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import DataTable from "react-data-table-component";

import { Padding } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";


const BulkUpdateStudents = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const [searchText, setSearchText] = useState("");

    const [classes, setClasses] = useState([]);
    const [sections, setSections] = useState([]);
    const [students, setStudents] = useState([]);
    const [filter, setFilter] = useState({ class_id: 0, section_id: 0 });

    // Fetch classes
    const fetchClasses = async () => {
        try {
            const response = await axios.post(`${baseUrl}/classes/`, {
                action: "READ",
                school_id: userObj.school_id
            });
            setClasses(response.data || []);
        } catch (error) {
            console.error("Error fetching classes:", error);
        }
    };

    // Fetch sections for selected class
    const fetchSections = async (class_id) => {
        try {
            const response = await axios.post(`${baseUrl}/getsectionsbyteachersubjectmap/`, {
                action: "SECTIONREAD",
                school_id: userObj.school_id,
                class_id,
                academic_year_id: userObj.academic_year_id
            });
            setSections(response.data || []);
        } catch (error) {
            console.error("Error fetching sections:", error);
        }
    };

    // Fetch students based on filter
    const fetchStudents = async () => {
        try {
            const payload = {
                action: "FILTER",
                school_id: userObj.school_id,
                academic_year_id: userObj.academic_year_id,
                class_id: filter.class_id || 0,
                section_id: filter.section_id || 0
            };
            const response = await axios.post(`${baseUrl}/students/`, payload);

            // Map gender to M/F
            const mapped = (response.data || []).map(s => ({
                ...s,
                gender: s.gender
                    ? s.gender.toUpperCase().startsWith('F')
                        ? 'F'
                        : 'M'
                    : '',
                status: s.status === 'Active' ? 'A'
                    : s.status === 'InActive' ? 'I'
                        : ''
            }));
            setStudents(mapped);

        } catch (error) {
            console.error("Error fetching students:", error);
        }
    };

    useEffect(() => {
        fetchClasses();
    }, []);

    useEffect(() => {
        if (filter.class_id) {
            fetchSections(filter.class_id);
        } else {
            setSections([]);
        }
    }, [filter.class_id]);

    useEffect(() => {
        fetchStudents();
    }, [filter.class_id, filter.section_id]);

    // Handle inline edits
    const handleInputChange = (e, student_id) => {
        const { name, value } = e.target;
        setStudents(prev =>
            prev.map(student => {
                if (student.student_id === student_id) {
                    let newValue = value;
                    // force gender to uppercase
                    if (name === "gender") {
                        newValue = value.toUpperCase();

                    }
                    if (name === "father_user_id" || name === "mother_user_id") {
                        return { ...student, [name]: parseInt(value || "0", 10) };
                    }
                    if (name === "class_id") {
                        return { ...student, class_id: parseInt(newValue) || 0, section_id: 0 };
                    }
                    return { ...student, [name]: newValue };
                }
                return student;
            })
        );
    };
const toNullableDate = (v) => {
  if (!v) return null;                 // "" / undefined / null
  const s = String(v).trim();
  if (s === "") return null;
  // if it is ISO datetime like "2026-03-10T00:00:00", keep only date
  return s.length >= 10 ? s.slice(0, 10) : null;
};


    // Handle save
    const handleSave = async () => {
        try {
            const updatedStudents = students
                .filter(s => selectedIds.includes(s.student_id))
                .map(s => ({
                    ...s, action: "UPDATE", father_user_id: parseInt(s.father_user_id || 0, 10), dob: toNullableDate(s.dob),
                    mother_user_id: parseInt(s.mother_user_id || 0, 10),  lastmodifiedby: userObj.user_name
                }));

            if (updatedStudents.length === 0) {
                toast.warning("Please select at least one student to update.");
                return;
            }

            await axios.post(`${baseUrl}/students/bulk-update/`, updatedStudents);
            toast.success("Selected students updated successfully!");
            fetchStudents();
        } catch (error) {
            console.error("Error updating students:", error);
            toast.error("Error updating students.");
        }
    };

    const [allSections, setAllSections] = useState([]);

    const fetchAllSections = async () => {
        try {
            const response = await axios.post(`${baseUrl}/Sections/`, {
                action: "READ",
                school_id: userObj.school_id,
                academic_year_id: userObj.academic_year_id
            });
            setAllSections(response.data || []);
        } catch (error) {
            console.error("Error fetching sections:", error);
        }
    };

    useEffect(() => {
        fetchAllSections();
    }, []);
    const [selectedIds, setSelectedIds] = useState([]);

    const handleSelectRow = (student_id) => {
        setSelectedIds((prev) =>
            prev.includes(student_id)
                ? prev.filter(id => id !== student_id)
                : [...prev, student_id]
        );
    };

    const handleSelectAll = () => {
        if (selectedIds.length === students.length) {
            setSelectedIds([]);
        } else {
            setSelectedIds(students.map(s => s.student_id));
        }
    };

    // DataTable columns
    const columns = [

        {
            name: (
                <Form.Check
                    type="checkbox"
                    checked={selectedIds.length === students.length && students.length > 0}
                    onChange={handleSelectAll}
                />
            ),
            cell: row => (
                <Form.Check
                    type="checkbox"
                    checked={selectedIds.includes(row.student_id)}
                    onChange={() => handleSelectRow(row.student_id)}
                />
            ),
            width: "20px",
            style: {
                paddingLeft: "10px"
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        },
        {
            name: "Student ID",
            selector: row => row.student_id,
            cell: row => (
                <span>{row.student_id || ""}</span>
            ),
            width: "120px"
        }
        ,
        {
            name: "Student FName",
            selector: row => row.student_first_name,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="student_first_name"
                    placeholder="First Name"
                    value={row.student_first_name || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "120px"
        },

        {
            name: "Student LName",
            selector: row => row.student_last_name,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="student_last_name"
                    placeholder="Last Name"
                    value={row.student_last_name || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "120px"
        },

        {
            name: "Adm No",
            selector: row => row.admission_number,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="admission_number"
                    placeholder="Admission Number"
                    value={row.admission_number || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "120px",
            style: {
                paddingLeft: "6px"
            }
        },


        {
            name: "Class",
            selector: row => row.class_name,
            cell: row => (
                <Form.Select
                    size="sm"
                    name="class_id"
                    value={row.class_id || 0}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                >
                    <option value={0}>Select</option>
                    {classes.map(cls => (
                        <option key={cls.class_id} value={cls.class_id}>
                            {cls.class_name}
                        </option>
                    ))}
                </Form.Select>
            ),
            width: "140px"
        },
        {
            name: "Section",
            selector: row => row.section_name,
            cell: row => (
                <Form.Select
                    size="sm"
                    name="section_id"
                    value={row.section_id || 0}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                >
                    <option value={0}>--</option>
                    {allSections
                        .filter(sec => sec.class_id === row.class_id)
                        .map(sec => (
                            <option key={sec.section_id} value={sec.section_id}>
                                {sec.section_name}
                            </option>
                        ))}
                </Form.Select>
            ),
            width: "100px"
        },

        {
            name: "Roll",
            selector: row => row.roll_no,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="roll_no"
                    value={row.roll_no || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                    style={{ maxWidth: "50px" }}
                />
            ),
            width: "55px"
        },
        {
            name: "Father User ID",
            selector: row => row.father_user_id,
            cell: row => (
                <Form.Control
                    type="number"
                    size="sm"
                    name="father_user_id"
                    value={row.father_user_id ?? 0}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                    style={{ maxWidth: "90px" }}
                />
            ),
            width: "130px"
        },
        {
            name: "Mother User ID",
            selector: row => row.mother_user_id,
            cell: row => (
                <Form.Control
                    type="number"
                    size="sm"
                    name="mother_user_id"
                    value={row.mother_user_id ?? 0}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                    style={{ maxWidth: "90px" }}
                />
            ),
            width: "130px"
        },
        {
            name: "Father Surname",
            selector: row => row.father_surname,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="father_surname"
                    placeholder="Father Surname"
                    value={row.father_surname || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "120px"
        },
        {
            name: "Father First Name",
            selector: row => row.father_firstname,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="father_firstname"
                    placeholder="Father First"
                    value={row.father_firstname || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "120px",
            style: {
                paddingLeft: "6px"
            }
        },


        {
            name: "Mother Surname",
            selector: row => row.mother_surname,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="mother_surname"
                    placeholder="Mother Surname"
                    value={row.mother_surname || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "120px"
        },
        {
            name: "Mother First Name",
            selector: row => row.mother_firstname,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="mother_firstname"
                    placeholder="Mother First"
                    value={row.mother_firstname || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "120px"
        },
        {
            name: "DOB",
            selector: row => row.dob,
            cell: (row) => (
                <Form.Control
                    type="date"
                    size="sm"
                    name="dob"
                    value={row.dob ? row.dob.slice(0, 10) : ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "140px",
        },
        {
            name: "Date of Join",
            selector: row => row.date_of_join,
            cell: row => (
                <Form.Control
                    type="date"
                    size="sm"
                    name="date_of_join"
                    value={row.date_of_join ? row.date_of_join.slice(0, 10) : ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "160px"
        }
        ,

        {
            name: "Father Mobile",
            selector: row => row.father_phone_number,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="father_phone_number"
                    value={row.father_phone_number || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "140px"
        },
        {
            name: "Mother Mobile",
            selector: row => row.mother_phone_number,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="mother_phone_number"
                    value={row.mother_phone_number || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "140px"
        },
        {
            name: "Father Aadhar",
            selector: row => row.father_aadhar_number,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="father_aadhar_number"
                    value={row.father_aadhar_number || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "160px"
        },
        {
            name: "Mother Aadhar",
            selector: row => row.mother_aadhar_number,
            cell: row => (
                <Form.Control
                    type="text"
                    size="sm"
                    name="mother_aadhar_number"
                    value={row.mother_aadhar_number || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                />
            ),
            width: "160px"
        }
        ,
        {
            name: "Gender",
            selector: row => row.gender,
            cell: row => (
                <Form.Select
                    size="sm"
                    name="gender"
                    value={row.gender || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                >
                    <option value="">Select</option>
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                </Form.Select>

            ),
            width: "100px"
        }, {
            name: "Status",
            selector: row => row.status,
            cell: row => (
                <Form.Select
                    size="sm"
                    name="status"
                    value={row.status || ""}
                    onChange={(e) => handleInputChange(e, row.student_id)}
                >
                    <option value="">Select</option>
                    <option value="A">Active</option>
                    <option value="I">Inactive</option>
                </Form.Select>
            ),
            width: "120px"
        }

    ];
    const filteredStudents = students.filter((s) => {
        const term = searchText.toLowerCase();
        return (
            s.student_first_name?.toLowerCase().includes(term) ||
            s.student_last_name?.toLowerCase().includes(term) ||
            s.admission_number?.toLowerCase().includes(term) ||
            s.roll_no?.toString().includes(term)
        );
    });



    return (


        <div className="pageBody">
            <ToastContainer />
            <Container fluid className="px-0">
                <Row className="g-0">
                    <Col xs={12} className="p-0">
                        <h5 className="mb-2">Bulk Update Students</h5>
                    </Col>
                </Row>

                <Row className="g-0 mb-3">
                    <Col md={4} sm={6} xs={12} className="p-0">
                        <Form.Group>
                            <Form.Label>Class</Form.Label>
                            <Form.Select
                                value={filter.class_id}
                                onChange={(e) =>
                                    setFilter({ ...filter, class_id: parseInt(e.target.value) || 0 })
                                }
                            >
                                <option value={0}>Select Class</option>
                                {classes.map(cls => (
                                    <option key={cls.class_id} value={cls.class_id}>
                                        {cls.class_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={4} sm={6} xs={12} className="p-0">
                        <Form.Group>
                            <Form.Label>Section</Form.Label>
                            <Form.Select
                                value={filter.section_id}
                                onChange={(e) =>
                                    setFilter({ ...filter, section_id: parseInt(e.target.value) || 0 })
                                }
                                disabled={!sections.length}
                            >
                                <option value={0}>Select Section</option>
                                {sections.map(sec => (
                                    <option key={sec.section_id} value={sec.section_id}>
                                        {sec.section_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className="g-0 mb-3">
                    <Col xs={12} md={6}>
                        <Form.Control
                            type="text"
                            placeholder="Search students..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            size="sm"
                        />
                    </Col>
                </Row>


                <Row className="g-0">
                    <Col xs={12} className="p-0">
                        <DataTable
                            columns={columns}
                            data={filteredStudents}
                            dense
                            pagination
                            highlightOnHover
                            responsive
                            fixedHeader
                            fixedHeaderScrollHeight="400px"
                            noDataComponent="No students found."
                            persistTableHead
                            customStyles={{
                                headCells: {
                                    style: {
                                        whiteSpace: "normal",
                                        textAlign: "center",
                                        fontSize: "13px",
                                        lineHeight: "1.2",
                                        paddingLeft: "12px",

                                    }
                                },
                                cells: {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                        padding: "4px",
                                        fontSize: "12px",
                                        lineHeight: "1.2",
                                        whiteSpace: "normal"
                                    }
                                }
                            }}
                        />


                    </Col>
                </Row>

                <Row className="mt-3 g-0">
                    <Col className="text-end p-0">
                        <Button variant="secondary" className="me-2" onClick={() => navigate('/students')}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleSave}>
                            Save Changes
                        </Button>
                    </Col>
                </Row>

            </Container>
        </div>


    );
};

export default BulkUpdateStudents;
